module.exports = __webpack_public_path__ + "static/media/app-oil.1b9ca26b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app-oil.png
// module id = 90
// module chunks = 0